








import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class LocaleChanger extends Vue {
    protected langs: string[] = ['en', 'nl'];
}
